__webpack_require__.p = "/nqueens/";